<template>
  <div id="app">
    <div>
      <confirm ref="confirm" />
      <loader v-model="statusval.loading" />
      <arksnackbar v-model="statusval" />
    </div>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar dark color="info">
              <v-toolbar-title>
                <v-layout align-center>Adres Aktarımı</v-layout>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="green" text @click="downloadSampleFile">
                Örnek Dosyayı İndir
              </v-btn>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-layout row wrap align-center>
              <v-flex xs12 sm12 md6>
                <v-layout align-center>
                  <v-form
                    ref="formaktarim"
                    method="post"
                    enctype="multipart/form-data"
                    v-model="valid"
                    lazy-validation
                  >
                    <input
                      hidden
                      type="file"
                      ref="files"
                      multiple
                      accept=".csv, .xls, .xlsx"
                      @change="handleFilesUpload"
                    />
                  </v-form>
                  <v-btn color="info" dark @click="addFiles">
                    <v-icon left>attach_file</v-icon>
                    Adres Dosyası Seçiniz
                  </v-btn>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="files.length"
                        color="info"
                        fab
                        small
                        class="ml-3"
                        @click="submitFiles"
                        :loading="statusval.loading"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark>mdi-upload</v-icon>
                      </v-btn>
                    </template>
                    <span>Seçilen dosyaları aktar</span>
                  </v-tooltip>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm12 md6>
                <v-layout justify-start>
                  <v-alert
                    :value="true"
                    :color="alertcolor"
                    icon="info"
                    outlined
                    class="ma-0"
                    style="max-width: 100%"
                  >
                    {{ alertmessage }}
                  </v-alert>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>

          
        <!-- Sonuçlar Bölümü -->
          <v-container fluid>
            <v-layout row wrap>
              
              <!-- Aktarılanlar -->
              <v-flex xs12 md6>
                <v-card class="mb-4" outlined>
                  <v-card-title primary-title class="blue white--text">
                    Aktarılanlar
                  </v-card-title>
                  <v-card-text>
                    <p v-if="uploadResult.aktarilanlar.length > 0">Aktarım Başarılı!</p>
                    <ul>
                      <li v-for="(item, index) in uploadResult.aktarilanlar" :key="index">
                        {{ item.Ad }} {{ item.Soyad }} - {{ item.Adres }} 
                        
                      </li>
                       <li v-for="(item, index) in uploadResult.aktarilanlar" :key="index">
                          {{ item.TC }} - {{ item.Telefon }}
                        </li>
                    </ul>
                    <p v-if="uploadResult.aktarilanlar.length === 0">Henüz başarılı aktarım yok.</p>
                  </v-card-text>
                </v-card>
              </v-flex>

              <!-- Aktarılamayanlar -->
              <v-flex xs12 md6>
                <v-card class="mb-4" outlined>
                  <v-card-title primary-title class="red white--text">
                    Aktarılamayanlar
                  </v-card-title>
                  <v-card-text>
                    <p v-if="uploadResult.aktarilamayanlar.length > 0">Aktarım Başarısız!</p>
                    <ul>
                      <li v-for="(item, index) in uploadResult.aktarilamayanlar" :key="index">
                        {{ item.Ad }} {{ item.Soyad }} - Hata: {{ item.Hata || 'Bilinmiyor' }}
                      </li>
                    </ul>
                    <p v-if="uploadResult.aktarilamayanlar.length === 0">Henüz başarısız aktarım yok.</p>
                  </v-card-text>
                </v-card>
              </v-flex>

            </v-layout>
          </v-container>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>

  
  <script>
import confirm from '@/components/app/coper/comp/confirm.vue';
import loader from '@/components/app/coper/comp/loader.vue';
import arksnackbar from '@/components/app/coper/comp/arksnackbar.vue';
import tool from '@/components/app/coper/tools';

export default {
  components: { confirm, loader, arksnackbar },
  data() {
    return {
      files: [],
      alertcolor: 'red',
      alertmessage: 'Henüz dosya seçilmedi',
      valid: true,
      uploadResult: {
        aktarilanlar: [],
        aktarilamayanlar: []
      },
     




    };
  },
  computed: {
  statusval() {
    return this.status != null ? this.status : tool.NewSatatus();
  },
  aktarilanlarWithRowNumbers() {
    return this.uploadResult.aktarilanlar.map((item, index) => ({
      rowNumber: index + 1,
      ...item
    }));
  },
  aktarilamayanlarWithRowNumbers() {
    return this.uploadResult.aktarilamayanlar.map((item, index) => ({
      rowNumber: index + 1,
      ...item
    }));
  }
},
  methods: {
    handleFilesUpload() {
      this.files = Array.from(this.$refs.files.files);
      if (this.files.length > 0) {
        this.alertcolor = 'success';
        this.alertmessage = `${this.files.length} adet dosya seçildi.`;
      } else {
        this.alertcolor = 'red';
        this.alertmessage = 'Henüz dosya seçilmedi.';
      }
    },
    addFiles() {
      this.$refs.files.click();
    },
    async submitFiles() {
      const confirmResult = await this.$refs.confirm.open(
        'Adres Aktarımı',
        'Seçilen dosyaları aktarmak istediğinizden emin misiniz?',
        { color: 'info' }
      );
      if (!confirmResult) return;

      const formData = new FormData();
      this.files.forEach((file, i) => {
        formData.append(`files[${i}]`, file);
      });

      this.statusval.loading = true;
      try {
        const response = await tool.api_file_post(this, 'Coper/AdresAktarimStream', formData);
        const data = response.body || response;
    

        this.uploadResult = {
          aktarilanlar: data.Liste.Aktarilan || [],
          aktarilamayanlar: data.Liste.Aktarilamayan || []
        };
        

        this.alertcolor = 'success';
        this.alertmessage = `Aktarım tamamlandı. Başarılı: ${this.uploadResult.aktarilanlar.length}, Hatalı: ${this.uploadResult.aktarilamayanlar.length}`;
      } catch (err) {
        console.error('Adres aktarımı hatası:', err);
        this.alertcolor = 'red';
        this.alertmessage = 'Aktarım sırasında hata oluştu.';
      } finally {
        this.statusval.loading = false;
      }
    },
    async downloadSampleFile() {
      const fileName = 'import_adres_aktarim.xlsx';
      const prm = { FileName: fileName };

      this.statusval.loading = true;
      try {
    
    const response = await tool.api_post_FileDownload(this, 'CariStream/DownloadFile', {
        FileName: 'import_adres_aktarim.xlsx'  
    });
    
    
    tool.CreateDownloadLink(response, 'import_adres_aktarim.xlsx');
} catch (error) {
    console.error('Dosya indirme hatası:', error);
    this.alertcolor = 'red';
    this.alertmessage = 'Örnek dosya indirilemedi.';
} finally {
    this.statusval.loading = false;
}

    }
  }
};
</script>

  